import { render, staticRenderFns } from "./CompetencyRatings.vue?vue&type=template&id=43518a22"
import script from "./CompetencyRatings.vue?vue&type=script&lang=js"
export * from "./CompetencyRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports